import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import Creatable from 'react-select/lib/Creatable';
import ProcessUtils from 'utils/ProcessUtils';
import Constants from 'utils/Constants';
import ModalsService from 'services/ModalsService';
import { Button } from 'antd';
import { Modal } from 'react-bootstrap';

/**
 * A simple form that lets you prompt for the name of a new entity.  The name can be either a single input
 * or a select combo box.
 */
export default class NewRetrievalRuleVariable extends React.Component {
    static propTypes = {
        process: PropTypes.object,
        inputDatasetName: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            prefix: '',
            value: '',
            invalid: false,
            errorMessage: null
        };
    }

    promptTextCreator = (label) => {
        return `Select custom value: ${label}`;
    };

    onVariableSelectChange = (value) => {
        this.setState({ value });
    };

    onPrefixInputChange = (e) => {
        this.setState({ prefix: e.target.value });
    };

    getNewVariables = () => {
        const value = this.state.value;
        let newVariables = null;

        if (Array.isArray(value)) {
            newVariables = value.map(valueObject => {
                return `${this.state.prefix}${valueObject.value}`;
            });
        }

        return newVariables;
    };

    setInvalid = (errorMessage) => {
        this.setState({ invalid: true, errorMessage });
    };

    onOk = () => {
        const addVariables = this.getNewVariables();
        const existingList = Object.keys(this.props.process.variable_retrieval.retrieved_variables);

        let invalid = [];
        addVariables.forEach(name => {
            const validator = ProcessUtils.getValidator(this.props.process);
            const valid = validator.isRetrievedVariableNameValid(name, existingList);

            if (valid.level !== null) {
                invalid.push(`${name}: ${valid.message}`);
            }
        });

        if (invalid.length > 0) {
            this.setInvalid(invalid)

        } else {
            const editor = ProcessUtils.getEditor(this.props.process);
            addVariables.forEach(name => {
                editor.addRetrievedVariable(this.props.inputDatasetName, name);
            });
            editor.commit();
            ModalsService.closeModal(ModalsService.TYPE_DATASET_VARIABLE);
        }
    };

    onCancel = () => {
        ModalsService.closeModal(ModalsService.TYPE_DATASET_VARIABLE);
    };

    renderErrorMessages = () => {
        return (this.state.errorMessage.map((msg, index) => {
            return <p key={index}>{msg}</p>;
        }));
    };

    render() {
        let value = this.state.value;

        let options = [];
        const datastreams = ProcessUtils.getInputDatastreamsForDataset(this.props.process, this.props.inputDatasetName);
        datastreams.forEach(ds => {
            const dodVars = ProcessUtils.getDatastreamVariablesForDod(ds);
            options = options.concat(Object.keys(dodVars));
        });
        options = Constants.convertArrayToSelectOptions(options);

        const labelClass = css`width:80px;`;

        return (
            <React.Fragment>
                <Modal.Header>
                    <Modal.Title>Add Retrieved Variables</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Flexbox flexDirection="column">
                        <Flexbox alignItems="center" flexDirection="row" className={css`margin-bottom: 10px;`}>
                            <div className={labelClass}>Variables:</div>
                            <div style={ { flexGrow: 1 } }>
                                <Creatable
                                    classNamePrefix="react-select"
                                    value={value}
                                    options={options}
                                    onChange={this.onVariableSelectChange}
                                    promptTextCreator={this.promptTextCreator}
                                    autoFocus
                                    isMulti
                                    isClearable
                                />
                            </div>
                        </Flexbox>
                        <Flexbox alignItems="center" flexDirection="row">
                            <div className={labelClass}>Add prefix:</div>
                            <div style={ { flexGrow: 1} }>
                                <input
                                    className={''}
                                    style={ { flexGrow: 1 } }
                                    onChange={this.onPrefixInputChange}
                                    value={this.state.prefix}
                                />
                            </div>
                        </Flexbox>
                        { this.state.invalid &&
                        <div className={'invalid'} style={ {marginTop: '15px'} }>
                            {this.renderErrorMessages()}
                        </div>
                        }
                    </Flexbox>
                </Modal.Body>

                <Modal.Footer>
                    <Button type="primary" onClick={this.onOk}>
                        OK
                    </Button>
                    <Button onClick={this.onCancel}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/modals/NewRetrievalRuleVariable.js